module.exports = __webpack_public_path__ + "img/avatar6.d4608336.png";